import React from "react";
import { Link } from "react-router-dom";

export default function NotFound({ isDarkMode, toggleDarkMode }) {
  
  const themeBg = isDarkMode 
    ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)'
    : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
  const themeCardBg = isDarkMode ? 'rgba(20, 20, 20, 0.9)' : 'rgba(255, 255, 255, 0.1)';
  const themeBorder = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.2)';
  const themeTextMuted = isDarkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.7)';

  return (
    <div 
      className={isDarkMode ? '' : ''}
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        padding: window.innerWidth <= 768 ? '1rem' : '2rem',
        background: themeBg,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        position: 'relative',
        transition: 'background 0.3s ease'
      }}
    >
      
      <div 
        className={isDarkMode ? '' : 'card shadow-lg'}
        style={{
          background: themeCardBg,
          backdropFilter: isDarkMode ? 'blur(10px)' : 'blur(10px)',
          borderRadius: '1rem',
          padding: '3rem',
          textAlign: 'center',
          maxWidth: '28rem',
          border: `1px solid ${themeBorder}`,
          boxShadow: isDarkMode ? '0 8px 32px rgba(0, 0, 0, 0.5)' : '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
        }}
      >
        <div style={{
          fontSize: window.innerWidth <= 768 ? '3rem' : '5rem',
          marginBottom: '1.5rem',
          color: isDarkMode ? '#667eea' : '#667eea'
        }}>
          <i className="fas fa-exclamation-circle"></i>
        </div>
        <h1 style={{
          fontSize: window.innerWidth <= 480 ? '2.5rem' : (window.innerWidth <= 768 ? '3rem' : '3.75rem'),
          fontWeight: '700',
          marginBottom: '1rem',
          color: isDarkMode ? 'white' : 'transparent',
          background: isDarkMode 
            ? 'none'
            : 'linear-gradient(to right, #667eea, #764ba2)',
          WebkitBackgroundClip: isDarkMode ? 'unset' : 'text',
          WebkitTextFillColor: isDarkMode ? 'white' : 'transparent',
          backgroundClip: isDarkMode ? 'unset' : 'text',
          marginTop: 0
        }}>
          404
        </h1>
        <p style={{
          fontSize: window.innerWidth <= 768 ? '1rem' : '1.25rem',
          color: themeTextMuted,
          marginBottom: '2rem',
          marginTop: 0
        }}>
          Lost in Code
        </p>
        <p style={{
          color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.5)',
          marginBottom: '2rem',
          marginTop: 0
        }}>
          The page you're looking for doesn't exist
        </p>
        <Link to="/dashboard" style={{ textDecoration: 'none' }}>
          <button
            className={isDarkMode ? '' : 'btn btn-primary shadow'}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              background: isDarkMode 
                ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '0.75rem',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: isDarkMode 
                ? '0 4px 15px rgba(102, 126, 234, 0.4)'
                : '0 4px 15px rgba(102, 126, 234, 0.4)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05) translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.5)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1) translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
            }}
          >
            <i className="fas fa-home"></i>
            Return Home
          </button>
        </Link>
      </div>
    </div>
  );
}

